import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
const parkingKeys = {
    all: ['parkings'],
    get: (filter, scope) => ['parkings', filter, scope],
};
export const parkingOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: parkingKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Parking);
            return await repo.get(filter, scope);
        },
    }),
};
